'use strict';

var processInclude = require('base/util');

var baseFiles = {
    // JQuery Dependent File
    loyaltyModalUtils: require('./components/loyaltyModalUtils')
};

module.exports = {
    baseFiles
};

$(document).ready(function () {
    Object.keys(baseFiles).forEach(function (key) {
        processInclude(baseFiles[key]);
    });
});
